module.exports = __webpack_public_path__ + "static/media/vk-white.290b9c06.svg";